module.exports = flarum.core.compat['components/Composer'];